module.exports = __webpack_public_path__ + "img/1510212404.c199f039.jpg";